import httpService from './httpService';
import config from '../config.json';

async function getUser(id) {
  let user = null;
  const result = await httpService.get(config.apiEndpoint + 'users/' + id);
  if (result.data.isOk) {
    user = result.data.user;
  }
  return user;
}
export default {
  getUser
};
